import { useEffect } from 'react'

let lockCount = 0
let savedStyles = null

function lockScroll() {
  const html = document.documentElement
  const body = document.body
  if (lockCount === 0) {
    savedStyles = {
      htmlOverflow: html.style.overflow,
      bodyOverflow: body.style.overflow,
      htmlOverscroll: html.style.overscrollBehavior,
      bodyOverscroll: body.style.overscrollBehavior,
      bodyPaddingRight: body.style.paddingRight,
    }
    const scrollbarWidth = window.innerWidth - html.clientWidth
    html.style.overflow = 'hidden'
    body.style.overflow = 'hidden'
    html.style.overscrollBehavior = 'none'
    body.style.overscrollBehavior = 'none'
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`
    }
  }
  lockCount += 1
}

function unlockScroll() {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount > 0 || !savedStyles) return
  const html = document.documentElement
  const body = document.body
  html.style.overflow = savedStyles.htmlOverflow
  body.style.overflow = savedStyles.bodyOverflow
  html.style.overscrollBehavior = savedStyles.htmlOverscroll
  body.style.overscrollBehavior = savedStyles.bodyOverscroll
  body.style.paddingRight = savedStyles.bodyPaddingRight
  savedStyles = null
}

/** True if the event target sits inside a real scrollable region (overflow + content). */
function isInsideScrollableContainer(target) {
  let node = target instanceof Element ? target : target?.parentElement
  while (node && node !== document.body && node !== document.documentElement) {
    const style = window.getComputedStyle(node)
    const canY = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1
    const canX = /(auto|scroll)/.test(style.overflowX) && node.scrollWidth > node.clientWidth + 1
    if (canY || canX) return true
    node = node.parentElement
  }
  return false
}

export function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active) return

    lockScroll()

    // Allow wheel/touch inside modal scroll areas (e.g. time slots).
    // Only block page scroll when the gesture is outside those areas.
    const onWheel = (event) => {
      if (!isInsideScrollableContainer(event.target)) {
        event.preventDefault()
      }
    }

    const onTouchMove = (event) => {
      if (!isInsideScrollableContainer(event.target)) {
        event.preventDefault()
      }
    }

    document.addEventListener('wheel', onWheel, { passive: false })
    document.addEventListener('touchmove', onTouchMove, { passive: false })

    return () => {
      document.removeEventListener('wheel', onWheel)
      document.removeEventListener('touchmove', onTouchMove)
      unlockScroll()
    }
  }, [active])
}
